module.exports = __webpack_public_path__ + "media/Synchron_psycho.c6a79810.mp3";